<div
	#stickySpacer
	class="sticky-spacer"
	[ngClass]="{ active: isStickyActive }"
></div>
<div
	class="sticky-wrapper"
	[ngClass]="{ active: isStickyActive }"
	[style]="{ 'z-index': zIndex }"
>
	<div [ngClass]="{ 'app-container': isStickyActive }" #stickyContent>
		<ng-content></ng-content>
	</div>
</div>
